// Disclosure buttons keep category groups visible inside an open menu.
export function initDisclosureNavigation(root = document) {
    root.querySelectorAll('[data-disclosure-navigation]').forEach(initNavigation);
}

function initNavigation(header) {
    if (!header) return;

    const mobileToggle = header.querySelector('[data-disclosure-navigation-toggle]');
    const navigation = header.querySelector('[data-disclosure-navigation-panel]');
    const triggers = [...header.querySelectorAll('[data-disclosure-submenu-toggle]')];
    const desktop = window.matchMedia('(min-width: 1200px)');

    function setExpanded(trigger, expanded) {
        const panel = header.querySelector(`#${trigger.getAttribute('aria-controls')}`);
        trigger.setAttribute('aria-expanded', String(expanded));
        if (panel) panel.hidden = !expanded;
    }

    function closeSubmenus(except) {
        triggers.forEach(trigger => {
            if (trigger !== except) setExpanded(trigger, false);
        });
    }

    function closeNavigation() {
        closeSubmenus();
        mobileToggle?.setAttribute('aria-expanded', 'false');
        navigation?.classList.remove('is-open');
    }

    mobileToggle?.addEventListener('click', () => {
        const expanded = mobileToggle.getAttribute('aria-expanded') !== 'true';
        mobileToggle.setAttribute('aria-expanded', String(expanded));
        navigation?.classList.toggle('is-open', expanded);
        if (!expanded) closeSubmenus();
    });

    triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            const expanded = trigger.getAttribute('aria-expanded') !== 'true';
            closeSubmenus(trigger);
            setExpanded(trigger, expanded);
        });
    });

    header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const openTrigger = triggers.find(trigger => trigger.getAttribute('aria-expanded') === 'true');
        if (openTrigger) {
            setExpanded(openTrigger, false);
            openTrigger.focus();
        } else if (mobileToggle?.getAttribute('aria-expanded') === 'true') {
            closeNavigation();
            mobileToggle.focus();
        }
        event.stopPropagation();
    });

    document.addEventListener('click', event => {
        if (!header.contains(event.target)) closeNavigation();
    });

    header.addEventListener('focusout', event => {
        if (event.relatedTarget && !header.contains(event.relatedTarget)) closeNavigation();
    });

    desktop.addEventListener('change', closeNavigation);
}
